export enum ApplianceDetailsSteppedTestHooks {
  BrandApplianceBuiltInSelect = 'appliance-details-stepped-brand-appliance-built-in__radio-button',
  BrandApplianceCategorySelect = 'appliance-details-stepped-brand-appliance-category__radio-button',
  BrandApplianceSelect = 'appliance-details-stepped-brand-appliance__radio-button',
  BrandCodeFilterList = 'appliance-details-stepped-brand-code__filter-list',
  BrandRetailerSelect = 'appliance-details-stepped-brand-retailer__select',
  CalendarDatePicker = 'appliance-details-stepped__calendar-date-picker',
  FirstName = 'personal-details-first-name-text',
  Form = 'appliance-details-stepped-form',
  LastName = 'personal-details-last-name-text',
  ModelNumberSelectTypeAhead = 'appliance-details-stepped-model__select-typeahead',
  ModelNumberTextInput = 'appliance-details-stepped-model-input__fieldset-text',
  ModelSerialNumberFieldset = 'appliance-details-stepped-model-serial__fieldset',
  OverrideAddressSelectTypeAhead = 'personal-details-override-address-select-typeahead',
  PersonalDetailsFieldset = 'appliance-details-stepped-personal-details__fieldset',
  PriceBrandSelect = 'appliance-details-stepped-price-brand__select',
  PriceBrandRadioList = 'appliance-details-stepped-price-brand__radio-button-list',
  PurchasePrice = 'appliance-details-stepped-purchase-price__fieldset-text',
  RegistrationCodeTextInput = 'appliance-details-stepped-registration-code__fieldset-text',
  SerialNumberTextInput = 'appliance-details-stepped-serial-input__fieldset-text',
  Title = 'personal-details-title-select',
  WarrantyRadio = 'appliance-details-stepped-warranty__radio',
}
